import {createMuiTheme} from '@material-ui/core/styles';

// const primaryColor = "#1a237e"
export const primaryColor = '#0082ca';
export const raisedButtonPrimary = '#ff6b00';
export const secondaryColor = '#b1b1b1';
export const raisedButtonContained = '#858585';
export const raisedButtonContainedDefault = '#b1b1b1';

export const logoFileName = "/static/assets/logo.png"


export const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: primaryColor
    },
    secondary: {
      main: secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif'
    ].join(','),
  },  
  overrides: {
    MuiAppBar: {
      // Name of the component ⚛️ / style sheet
      root: {
        // Name of the rule
        // background: 'linear-gradient(0deg, #01070e 0%, #093170 10%, #0d47a1 90%, #01070e 100%)'
        background: 'linear-gradient(0deg, #ffffff 0%, #fafafa 100%)'
      },
      
    },
    MuiButton: {
      containedPrimary: {
        backgroundColor: raisedButtonPrimary
      },
      contained: {
        backgroundColor: raisedButtonContainedDefault,
        color: '#3a3a3a'
      },
      containedSecondary: {
        backgroundColor: raisedButtonContained
      },
      colorInherit: {
        color: "rgb(53, 124, 201) !important"
      }
    },
    MuiBadge: {
      colorPrimary: {
        backgroundColor: raisedButtonPrimary
      }
    },
    MuiFormLabel: {
      asterisk: {
        color: 'red',
        fontWeight: 600
      },
      root: {
        color: primaryColor
      }
    },
    MuiTypography: {
      h5: {
        fontSize: '1.75rem',
        fontWeight: 500,
        lineHeight: '1.20588em',
        marginBottom: 15,
        color: 'rgba(0, 0, 0, 0.54)'
      },
      subtitle1: {
        color: primaryColor
      }
    },
    MuiListSubheader: {
      sticky: {
        backgroundColor: '#fff'
      }
    },
    MuiExpansionPanel: {
      root: {
        position: "unset"
      }
    },
    MuiExpansionPanelSummary: {
      content: {
        margin: "0px 0px !important",
        padding: "0px 0px !important"
      },
      expanded: {
        margin: "0px 0px !important",
      },
      root: {
        margin: "0px 0px !important",
        padding: "0px 0px !important"
      }
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: "0px 0px 0px !important"
      }
    },
    MuiListItemIcon:{
      root:{
        minWidth: 0,
      }
    },
    MuiListItemText:{
      root:{
        paddingLeft: 10,
        color: primaryColor,
      }
    }
  }
});

export const styleRules = {
  root: {
    paddingTop: 75,
    paddingLeft: 15,
    paddingRight: 15
    //background: "black url(https://static.boydgaming.net/boydgaming/assets/shell/background.jpg) top no-repeat;",
  },
  toolbar: {
    '@media only print': {display: 'none'}
  },
  flex: {
    flex: 1
  },
  appTitle: {
    flex: 1,
    color: '#fff',
    marginTop: 5,
    fontFamily: 'Arial,san-serif,Helvetica,Trebuchet MS'
  },
  drawerList: {
    width: 300
  },
  menuButton: {
    color: "rgb(0, 130, 202) !important",
    marginLeft: -12,
    marginRight: 0
  },
  logo: {
    marginLeft: 10,
    marginTop: 0,
    height: 40,
    width: 'auto'
  },
  bottomPadding: {
    height: 60
  },
  chip: {
    margin: theme.spacing.unit
  },
  homeIcon: {
    marginRight: 10
  }
};


